import { useContext, useEffect } from 'react';
import { AppDataContext } from 'contexts/appData';
import { setUser } from 'libs/ga4/ga4';
import { getAccountType } from 'libs/ga4/helpers';

export const useSetGa4User = ({ user, shop }) => {
  const { getLang } = useContext(AppDataContext);

  const userId = user?.ID ? String(user.ID) : null;
  const userType = userId ? getAccountType(shop) : null;

  useEffect(() => {
    if(!user) return;

    const properties = { user_language: getLang };

    if (userType) {
      properties.user_type = userType;
    }

    setUser({ userId, properties });
  }, [getLang, userId, userType]);

  return null;
};
